import { TabStrip as KTabStrip } from "@progress/kendo-react-layout";

import type { PropsWithChildren } from "react";
import type { TabStripProps as KTabStripProps } from "@progress/kendo-react-layout";

export interface TabStripProps extends PropsWithChildren<KTabStripProps> {}

export const Tabstrip = function render(props: TabStripProps) {
  const { className, keepTabsMounted, animation, ...otherProps } = props;
  return (
    <KTabStrip
      className={`tc-tabstrip ${className}`}
      keepTabsMounted
      animation={false}
      {...otherProps}
    />
  );
};
